import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import React from 'react';
import { usePopupTrigger } from 'web/src/components/app/usePopupTrigger';
import { useAuthContext } from './AuthContext';
export function Auth() {
    const { user, signIn, signOut } = useAuthContext();
    return user != null
        ? React.createElement(UserMenu, { user: user, signOut: signOut })
        : React.createElement(WhiteIconButton, { onClick: signIn },
            React.createElement(PersonOutlineRoundedIcon, null));
}
function UserMenu({ user, signOut }) {
    const { controlButton, controlledPopover } = usePopupTrigger();
    if (user == null) {
        return null;
    }
    return React.createElement(React.Fragment, null,
        React.createElement(WhiteIconButton, { ...controlButton, size: "small" },
            React.createElement(UserAvatar, { variant: "circular", alt: user.name ?? user.email ?? undefined, src: user.image ?? undefined },
                React.createElement(PersonRoundedIcon, null))),
        React.createElement(Menu, { ...controlledPopover },
            React.createElement(MenuItem, { dense: true, onClick: signOut }, "Kil\u00E9p\u00E9s")));
}
const UserAvatar = styled(Avatar)(({ theme }) => ({
    backgroundColor: 'transparent',
    color: theme.palette.common.white,
    width: '24px',
    height: '24px',
    padding: 0
}));
const WhiteIconButton = styled(IconButton)(({ theme }) => ({
    color: theme.palette.common.white
}));
//# sourceMappingURL=Auth.js.map